import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=cf8893e6"
import script from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=cf8893e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports